import React from "react";
import { Row, Col} from "react-bootstrap";
import { community } from "../Models";

function CommunityWork() {
  return (


    <div class="card">
        {community.map((comm) => (
            <div>
            <div class="card-header" style={{textAlign:"left"}}><h3>{comm.title}</h3></div>
            <Row>
            <Col md={7} className="project-card" style={{textAlign:"left"}}>
            <h5><strong>{comm.position}</strong>: {comm.year}</h5> 
            <p>{comm.description}</p>
            <a href={comm.livePreview} style={{color:"black"}}>{comm.livePreview}</a>
          </Col>
          <Col md={4} className="project-card">
                <a href={comm.link} target="_blank" rel="noreferrer">
              <img src={comm.image} alt={comm.name} className="project_card_img" />
              </a>
          </Col>
          </Row>
          </div>
          ))}

       </div>
);
}

export default CommunityWork;